import React from 'react';

const Select = props => {
  const {
    id,
    label,
    className,
    options = [],
    handleChange,
    selected,
    name,
    labelClass,
    labelId,
    ...rest
  } = props;

  return (
    <div className={className}>
      {label && (
        <label id="select-label" className={labelClass} htmlFor={name}>
          {label}
        </label>
      )}
      <select
        id={id}
        data-testid={id}
        onChange={handleChange}
        value={selected || ''}
        name={name}
        aria-labelledby="select-label"
        {...rest}
      >
        {options.map(({name, value}) => (
          <option key={`${id}-${value}`} value={value}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
